<div class="fr-layout">

  <div class="fr-main">
    <h1 class="fr-title">Futár rendelés</h1>
    <p class="fr-sub">FedEx futár kérése a Spring GDS-től — a címkét emailben küldik.</p>

    <div class="fr-card" *ngIf="!sent">
      <div class="fr-label">Mikorra?</div>
      <div class="fr-chip-row">
        <button
          type="button"
          class="fr-chip"
          [class.fr-chip--on]="day === d"
          *ngFor="let d of dayChips"
          (click)="pickDay(d)">{{ d }}</button>
      </div>

      <div class="fr-label">Hány doboz?</div>
      <div class="fr-chip-row">
        <button
          type="button"
          class="fr-chip"
          [class.fr-chip--on]="boxes === n"
          *ngFor="let n of boxChips"
          (click)="pickBoxes(n)">{{ n }} doboz</button>
      </div>

      <div class="fr-label">Email előnézet</div>
      <div class="fr-email">{{ emailBody }}</div>

      <button type="button" class="fr-send" [disabled]="sending" (click)="send()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 3 L10.5 13.5"></path><path d="M21 3 L14.5 21 L10.5 13.5 L3 9.5 Z"></path></svg>
        Küldés
      </button>
    </div>

    <div class="fr-done" *ngIf="sent">
      <div class="fr-done__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7.5"></polyline></svg>
      </div>
      <h2 class="fr-done__title">Futár megrendelve</h2>
      <p class="fr-done__msg">{{ sentMsg }}</p>
      <div class="fr-email fr-done__email">{{ emailBody }}</div>
      <div class="fr-done__actions">
        <button type="button" class="fr-done__copy" (click)="copyEmail()">
          {{ copied ? 'Kimásolva' : 'Email másolása' }}
        </button>
        <button type="button" class="fr-done__again" (click)="reset()">Új futár rendelés</button>
      </div>
    </div>

    <div class="fr-history" *ngIf="pickupsLoaded">
      <div class="stk-section-title fr-history__kicker">Korábbi igénylések</div>
      <div class="fr-history__card">
        <div class="fr-history__empty" *ngIf="pickups.length === 0">Még nincs korábbi igénylés.</div>
        <div class="fr-history__row" *ngFor="let p of pickups; trackBy: trackById">
          <span class="fr-history__date">{{ p.pickupDate }}</span>
          <span class="fr-history__day">{{ dayLabelOf(p) }}</span>
          <span class="fr-history__boxes">{{ p.boxes }} doboz</span>
          <span class="fr-history__sent">küldve: {{ p.sentAt | date:'yyyy-MM-dd HH:mm' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Kapcsolat oldalsáv -->
  <div class="fr-side">
    <div class="fr-contact">
      <div class="fr-contact__kicker">Ha baj van</div>
      <div class="fr-contact__row">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8A9464" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" class="fr-contact__icon"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polyline points="3,7 12,13 21,7"></polyline></svg>
        <div class="fr-contact__copy">
          <div class="fr-contact__text">Nem érkezett címke, vagy bármi gond van:</div>
          <a href="mailto:customerservice.hu@spring-gds.com" class="fr-contact__mail">customerservice.hu&#64;spring-gds.com</a>
          <div class="fr-contact__phone-row"><a href="tel:+36209662307" class="fr-contact__phone">+36 20 966 2307</a></div>
        </div>
      </div>
      <div class="fr-contact__row fr-contact__row--last">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8A9464" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" class="fr-contact__icon"><path d="M5 4 h4 l2 5 -2.5 1.5 a11 11 0 0 0 5 5 L15 13 l5 2 v4 a2 2 0 0 1 -2 2 A16 16 0 0 1 3 6 a2 2 0 0 1 2 -2"></path></svg>
        <div class="fr-contact__copy">
          <div class="fr-contact__text">FedEx futár közvetlenül:</div>
          <a href="tel:+36303636583" class="fr-contact__phone fr-contact__phone--lg">+36 30 363 6583</a>
        </div>
      </div>
    </div>
  </div>

</div>
